import { Component, inject, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { LANGS } from '../../shared/constants/lang.constants';
import { ReactiveFormsModule } from '@angular/forms';
import { TextComponent } from '../../shared/components/text/text.component';
import { Router } from '@angular/router';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { CreateMemberRequest } from '../../shared/interfaces/set-password.model';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from "@angular/material/button";
import { ReportQueryService } from '../../shared/services/report-query.service';
import { HCReport, LatestReportRequest, LatestReportResponse, RecordList, ReportHistoryResponse } from '../../shared/interfaces/report-query.model';
import { ApiResponse } from '../../shared/interfaces/api-response.model';
import { FormatDateYearMonthDayPipe } from '../../pipes/format-date-year-month-day.pipe';
import { MatFormField } from "@angular/material/input";
import { MatSelect, MatOption, MatSelectTrigger } from "@angular/material/select";
import { KendoComponent } from '../../shared/components/kendo/kendo/kendo.component';
import { KENDO_CHARTS } from '@progress/kendo-angular-charts';
/**
 * 我的健檢與歷年報告
 */
@Component({
  selector: 'app-my-reports',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TextComponent,
    TranslatePipe,
    MatButton,
    FormatDateYearMonthDayPipe,
    MatFormField,
    MatSelect,
    MatOption,
    MatSelectTrigger,
    KendoComponent,
    KENDO_CHARTS

  ],
  templateUrl: './my-reports.component.html',
  styleUrl: './my-reports.component.scss',
})
export class MyReportsComponent {
  @ViewChild('reportLeftCart', { static: false }) reportLeftCart?: ElementRef;
  LANGS = LANGS;
  router: Router = inject(Router);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  createMemberRequest: CreateMemberRequest | null = null;
  isLoading: boolean = false;
  noData: boolean = false;
  noReportData: boolean = false;
  @Input() selectedTab: number = 0;
  currentPage = 1;
  pageSize = 5;
  status = ''; // 報告狀態
  selectedCategory: string = 'all'; // 改為 'all' 表示顯示全部
  reportQueryService: ReportQueryService = inject(ReportQueryService);
  examCategories: Array<{ examItem: string; name: string; hasAlert: boolean }> = [];
  // 歷年檢項數值紀錄
  historicalExamRecords: RecordList[] = [];

  latestReportResponse: LatestReportResponse | null = null;

  isReportCartOpen = false;
  historicalRecords: any[] = [];
  // 當前選中要查看歷年紀錄的檢項
  selectedExamForHistory: any = null;

  constructor(private renderer: Renderer2) { }

  // 假資料 - CB-023 歷年健檢報告
  allReports: HCReport[] = [
    // {
    //   "caseNo": "201234567",
    //   "bookDate": "20200701",
    //   "bookStatus": "1"
    // },
    // {
    //   "caseNo": "123456789",
    //   "bookDate": "20190701",
    //   "bookStatus": "8"
    // },
    // {
    //   "caseNo": "123456780",
    //   "bookDate": "20180701",
    //   "bookStatus": "9"
    // }
  ];



  // 假資料 - CB-054
  // mockData: ApiResponse<LatestReportResponse> = {
  //   "success": true,
  //   "statusCode": "S0000",
  //   "data": {
  //     "orgNo": "05",
  //     "bookDate": "20250509",
  //     "bookStatus": "9",
  //     "deptList": [
  //       {
  //         "deptName": "一般檢查",
  //         "deptEName": "General  Examination",
  //         "examItemList": [
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010001",
  //             "examName": "身高",
  //             "examEName": "Body Height",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "公分(cm)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "158.2"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010002",
  //             "examName": "體重",
  //             "examEName": "Body Weight",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "公斤(kg)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "48.4"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010017",
  //             "examName": "腰圍",
  //             "examEName": "Waistline",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<=80 (公分(cm))",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "78"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010019",
  //             "examName": "體脂肪率",
  //             "examEName": "Body Fat Percentage",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "20-27 (%)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "25.4"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010003",
  //             "examName": "理想體重",
  //             "examEName": "Ideal Body Weight",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "公斤(kg)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "55.1"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010006",
  //             "examName": "身體質量指數",
  //             "examEName": "Body Mass Index",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "18.50 - 23.99 (Kg/㎡)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "19.3"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010009",
  //             "examName": "坐姿收縮壓",
  //             "examEName": "SBP,Sitting",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<130 (mmHg)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "122"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010010",
  //             "examName": "坐姿舒張壓",
  //             "examEName": "DBP, sitting",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<85 (mmHg)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "71"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010008",
  //             "examName": "脈搏節律",
  //             "examEName": "Rhythm",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "規則 (Regular Rhythm of Pulsation)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010007",
  //             "examName": "脈搏數",
  //             "examEName": "Pulse Rate",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "50 - 100 (次/分(/min))",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "67"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "理學檢查",
  //         "deptEName": "Physical  Examination",
  //         "examItemList": [
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010025",
  //             "examName": "頭頸部",
  //             "examEName": "Head And Neck",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Conjunctiva:Not pale;Sclera:Not icteric;Neck:Supple.NO carotid bruit;Thyroid:No enlarged)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010026",
  //             "examName": "呼吸系統",
  //             "examEName": "Lung Examination",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Lung:Clear breathing sound)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010027",
  //             "examName": "心臟血管系統",
  //             "examEName": "Cardiovascular System",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Heart:Regular beats,no murmur)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010028",
  //             "examName": "消化系統",
  //             "examEName": "Digestive System",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Abdomen:Liver/Spleen impalpable,no tenderness)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010029",
  //             "examName": "神經系統",
  //             "examEName": "Neurology",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Nervous system(Sensory;Sleeping):Not Remarkable)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010030",
  //             "examName": "肌肉骨骼",
  //             "examEName": "Skeletal System",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Extremities:Free, normal range of motion)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00010031",
  //             "examName": "皮膚",
  //             "examEName": "Skin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Skin:No tinea)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "HI000002",
  //             "examName": "既往病史",
  //             "examEName": "Past Medical History",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "既往病史：高血脂、貧血\r\n手術史或重大外傷：剖腹產"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "HI000001",
  //             "examName": "自覺症狀",
  //             "examEName": "Chief Complaints",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "耳鳴"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "HI000003",
  //             "examName": "家族病史",
  //             "examEName": "Family History",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "高血脂、貧血"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "菸酒檳榔史",
  //             "groupEName": "History of Social Habits",
  //             "examItem": "HI000008",
  //             "examName": "嚼檳榔習慣",
  //             "examEName": "Habit of Chewing Betel Nuts",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "最近六個月內是否有嚼食檳榔：從未嚼食檳榔"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "菸酒檳榔史",
  //             "groupEName": "History of Social Habits",
  //             "examItem": "HI000006",
  //             "examName": "吸菸習慣",
  //             "examEName": "Smoking Habit",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "過去一個月內是否有吸菸：從未吸菸"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "菸酒檳榔史",
  //             "groupEName": "History of Social Habits",
  //             "examItem": "HI000007",
  //             "examName": "飲酒習慣",
  //             "examEName": "Drinking Habit",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "過去一個月內是否有喝酒：從未喝酒"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "HI000015",
  //             "examName": "飲食習慣",
  //             "examEName": "Eating habits",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "飲食習慣(可複選)：無"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "其它個人資料",
  //             "groupEName": "Other Personal History",
  //             "examItem": "HI000009",
  //             "examName": "運動習慣",
  //             "examEName": "Exercise Habit",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "1.運動習慣：有(接續填答5-9)\r\n5.運動禁忌(可複選)：無\r\n6.通常進行哪種運動(可複選)：球類運動\r\n7.每周運動頻率：31~60分鐘\r\n8.每次運動時間：61分鐘以上\r\n9.運動強度：中度 (運動中講話有點喘)"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "肺部檢查",
  //         "deptEName": "Lung Examination",
  //         "examItemList": [
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R132001D",
  //             "examName": "胸部X光（正面及左側面）",
  //             "examEName": "Chest X-ray,PA  & L Lat view",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "Widening of mediastinum is found. Mediastinal lesion such as aortic aneurysm or mediastinal tumor or just prominent vessel is suspected\r\nCalcification In Aortic Wall"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R132001D1",
  //             "examName": "胸部X光（正面及左側面）報告摘錄",
  //             "examEName": "Chest X-ray,PA  & L Lat view",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "縱膈腔變寬，疑縱膈腔病灶如主動脈瘤或縱膈腔腫瘤或明顯血管影像 (Widening of mediastinum is found. Mediastinal lesion such as aortic aneurysm or mediastinal tumor or just prominent vessel is suspected)"
  //               },
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "主動脈壁鈣化 (Calcification in Aortic Wall)"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "心血管及代謝系統",
  //         "deptEName": "Cardiovascular and Metabolic System",
  //         "examItemList": [
  //           {
  //             "groupName": "血脂肪",
  //             "groupEName": "Serum Lipid Profile",
  //             "examItem": "L3002000",
  //             "examName": "三酸甘油酯",
  //             "examEName": "Triglyceride",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<150 (mg/dL)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "69"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血脂肪",
  //             "groupEName": "Serum Lipid Profile",
  //             "examItem": "L3001900",
  //             "examName": "總膽固醇",
  //             "examEName": "Total cholesterol",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "< 200 (mg/dL)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "234"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血脂肪",
  //             "groupEName": "Serum Lipid Profile",
  //             "examItem": "L3003500",
  //             "examName": "高密度脂蛋白-膽固醇",
  //             "examEName": "HDL-C",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": ">50 (mg/dL)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "72"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血脂肪",
  //             "groupEName": "Serum Lipid Profile",
  //             "examItem": "L3005200",
  //             "examName": "低密度脂蛋白-膽固醇",
  //             "examEName": "LDL-C",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "< 130 (mg/dL)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "161"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血脂肪",
  //             "groupEName": "Serum Lipid Profile",
  //             "examItem": "L300350001",
  //             "examName": "總/高密度膽固醇比",
  //             "examEName": "Total/HDL Ratio",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<5",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "3.25"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血脂肪",
  //             "groupEName": "Serum Lipid Profile",
  //             "examItem": "L300350002",
  //             "examName": "低/高密度脂蛋白比值",
  //             "examEName": "LDL/HDL ratio",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<3",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "2.24"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血糖",
  //             "groupEName": "Blood Sugar",
  //             "examItem": "L3000800",
  //             "examName": "飯前血糖",
  //             "examEName": "Fasting blood sugar",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "70-99 (mg/dL)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "96"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血糖",
  //             "groupEName": "Blood Sugar",
  //             "examItem": "L3000700",
  //             "examName": "糖化血色素",
  //             "examEName": "Hemoglobin A1c",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "<5.7 (%)",
  //                 "isChart": true,
  //                 "isNum": true,
  //                 "rValue": "6.2"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血糖",
  //             "groupEName": "Blood Sugar",
  //             "examItem": "LI001700",
  //             "examName": "飯前胰島素",
  //             "examEName": "AC Insulin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "2.6-24.9 (μU/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "2.4"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "血糖",
  //             "groupEName": "Blood Sugar",
  //             "examItem": "LI001800",
  //             "examName": "胰島素阻抗評估",
  //             "examEName": "Homeostasis Model Assessment of Insulin Resistance",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<2.7",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0.6"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "甲狀腺功能",
  //             "groupEName": "Thyroid Function",
  //             "examItem": "LI000400",
  //             "examName": "甲狀腺刺激素",
  //             "examEName": "TSH",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0.27-4.2 (μIU/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "10.80"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "甲狀腺功能",
  //             "groupEName": "Thyroid Function",
  //             "examItem": "LI003400",
  //             "examName": "游離甲狀腺素",
  //             "examEName": "Free T4",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0.93-1.7 (ng/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.41"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R202600001",
  //             "examName": "甲狀腺超音波報告摘錄",
  //             "examEName": "Thyroid ECHO",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "雙側疑自體免疫性甲狀腺炎(Bilateral R/O Autoimmune Thyroiditis)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "靜式心電圖",
  //             "groupEName": "Resting EKG",
  //             "examItem": "L10011002",
  //             "examName": "平均心室率",
  //             "examEName": "Mean Ventricular Rate",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "50 - 100 (次/分(/min))",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "52"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "靜式心電圖",
  //             "groupEName": "Resting EKG",
  //             "examItem": "L10011003",
  //             "examName": "靜式心電圖報告摘錄",
  //             "examEName": "Resting EKG",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "竇性心搏過緩( Sinus Bradycardia)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R4014710",
  //             "examName": "周邊動脈硬化評估",
  //             "examEName": "Assessment of Atherosclerosis",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "雙側周邊血管有明顯的動脈硬化 (Peripheral vascular sclerosis)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471001",
  //             "examName": "右臂脈波傳導速度",
  //             "examEName": "RbaPWV",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1629"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471002",
  //             "examName": "左臂脈波傳導速度",
  //             "examEName": "LbaPWV",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1623"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471003",
  //             "examName": "右側踝臂血壓指數",
  //             "examEName": "Rabi",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.12"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471004",
  //             "examName": "左側踝臂血壓指數",
  //             "examEName": "Labi",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.16"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471005",
  //             "examName": "右側周邊血管彈性",
  //             "examEName": "Right side of the peripheral vascular elasticity",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "周邊血管有明顯的動脈硬化(baPWV≧1600cm/s) (Peripheral vascular sclerosis)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471006",
  //             "examName": "左側周邊血管彈性",
  //             "examEName": "Left side of the peripheral vascular elasticity",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "周邊血管有明顯的動脈硬化(baPWV≧1600cm/s) (Peripheral vascular sclerosis)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊動脈硬化評估 ",
  //             "groupEName": "Assessment of Atherosclerosis",
  //             "examItem": "R401471007",
  //             "examName": "右側周邊血管阻塞程度",
  //             "examEName": "Peripheral vascular occlusion of the right",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀(ABI 參考值1.0≦ABI≦1.4) (Normal)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R401471008",
  //             "examName": "左側周邊血管阻塞程度",
  //             "examEName": "Peripheral vascular occlusion of the left",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀(ABI 參考值 1.0≦ABI≦1.4) (Normal)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R401470005",
  //             "examName": "十年心血管疾病風險評估",
  //             "examEName": "The 10-year Cardiovascular Assessment",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "計算結果為5%；數值僅供參考，若您有已知之心血管疾病或患有糖尿病，無論計算後之心血管疾病發生率多少，您皆視同為高危險族群 （10年危險性＞20%）"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "消化系統",
  //         "deptEName": "Digestive System",
  //         "examItemList": [
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3000200",
  //             "examName": "麩胺酸苯醋酸轉氨基酶",
  //             "examEName": "GOT, AST",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "5-35 (IU/L)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "24"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3000300",
  //             "examName": "麩胺酸丙酮酸轉氨基酶",
  //             "examEName": "GPT, ALT",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "5-35 (IU/L)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "19"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3001800",
  //             "examName": "總蛋白",
  //             "examEName": "Total protein",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "6.3-8.5 (g/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "7.3"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L301810002",
  //             "examName": "白蛋白",
  //             "examEName": "Albumin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "3.5-5.2 (g/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "4.7"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L301810003",
  //             "examName": "球蛋白",
  //             "examEName": "Globulin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "2.5-3.6 (g/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "2.6"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L301810001",
  //             "examName": "白蛋白/球蛋白比例",
  //             "examEName": "A/G ratio",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "1.2-2",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.8"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3000400",
  //             "examName": "麩胺酸轉肽酶",
  //             "examEName": "γ-GT",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "5-36 (IU/L)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "13"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3000100",
  //             "examName": "鹼性磷酸酶",
  //             "examEName": "Alkaline phosphatase",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "35-104 (U/L)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "72"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3001700",
  //             "examName": "總膽紅素",
  //             "examEName": "Total bilirubin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0.2-1.2 (mg/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0.7"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝機能",
  //             "groupEName": "Liver Function",
  //             "examItem": "L3001710",
  //             "examName": "直接膽紅素",
  //             "examEName": "Direct bilirubin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0.1-0.5 (mg/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0.4"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝炎標記檢查",
  //             "groupEName": "Marker Of Viral Hepatitis",
  //             "examItem": "LG001400",
  //             "examName": "C型肝炎抗體測定",
  //             "examEName": "Anti-HCV",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<0.9Non-reactive",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "Non-reactive 0.04"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝炎標記檢查",
  //             "groupEName": "Marker Of Viral Hepatitis",
  //             "examItem": "L2001900",
  //             "examName": "B型肝炎表面抗原",
  //             "examEName": "HBsAg",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<0.9(-)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "Negative 0.38"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "肝炎標記檢查",
  //             "groupEName": "Marker Of Viral Hepatitis",
  //             "examItem": "L2002000",
  //             "examName": "B型肝炎表面抗體",
  //             "examEName": "Anti-HBs",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<10(-)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "Positive 237.00"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "糞便檢查",
  //             "groupEName": "Stool Routine Examination",
  //             "examItem": "L4002800",
  //             "examName": "潛血（酵素免疫）",
  //             "examEName": "OB, EIA",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "Negative (ng/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "Negative"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R202200001",
  //             "examName": "腹部超音波檢查報告摘錄",
  //             "examEName": "Upper Abdominal  Sonography Findings",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀( Not remarkable)"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "腎臟泌尿系統",
  //         "deptEName": "Kidney and Urology",
  //         "examItemList": [
  //           {
  //             "groupName": "腎機能",
  //             "groupEName": "Renal Function",
  //             "examItem": "L3001300",
  //             "examName": "尿素氮",
  //             "examEName": "Blood urea nitrogen",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "8-25 (mg/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "18"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "腎機能",
  //             "groupEName": "Renal Function",
  //             "examItem": "L3001400",
  //             "examName": "尿酸",
  //             "examEName": "Uric acid",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "2.4-5.7 (mg/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "6.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "腎機能",
  //             "groupEName": "Renal Function",
  //             "examItem": "L3001500",
  //             "examName": "肌酸酐",
  //             "examEName": "Creatinine",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0.5-0.9 (mg/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.07"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "腎機能",
  //             "groupEName": "Renal Function",
  //             "examItem": "L300150001",
  //             "examName": "腎絲球過濾率",
  //             "examEName": "eGFR",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "≧ 90",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "52"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200001",
  //             "examName": "外觀",
  //             "examEName": "Appearance",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "Light-Yellow/Clear"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200002",
  //             "examName": "尿糖",
  //             "examEName": "Glucose",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - ) - ( - )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200003",
  //             "examName": "尿膽紅素",
  //             "examEName": "Bilirubin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - ) - ( - )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200004",
  //             "examName": "尿酮",
  //             "examEName": "Ketone",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - ) - ( - )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200005",
  //             "examName": "尿比重",
  //             "examEName": "Specific gravity",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "1.005-1.030",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.014"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200006",
  //             "examName": "尿潛血",
  //             "examEName": "Occult Blood",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - ) - ( ± )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "+/-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200007",
  //             "examName": "酸鹼值",
  //             "examEName": "PH",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "5.0-8.0",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "6.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200008",
  //             "examName": "尿蛋白",
  //             "examEName": "Protein",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - ) - ( ± )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200009",
  //             "examName": "尿膽素原",
  //             "examEName": "Urobilinogen",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "<1.5",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "<1.5"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200010",
  //             "examName": "亞硝酸鹽",
  //             "examEName": "Nitrite",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿液檢查",
  //             "groupEName": "Urine Routine Examination",
  //             "examItem": "L400200011",
  //             "examName": "白血球",
  //             "examEName": "Leukocyte",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "( - ) - ( ± )",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿沉渣試驗",
  //             "groupEName": "Urinary Sediment",
  //             "examItem": "L400020001",
  //             "examName": "紅血球",
  //             "examEName": "Red blood cell",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0-3 (/HPF)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "4-5"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿沉渣試驗",
  //             "groupEName": "Urinary Sediment",
  //             "examItem": "L400020002",
  //             "examName": "白血球",
  //             "examEName": "White blood cell",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-5 (/HPF)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0-5"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿沉渣試驗",
  //             "groupEName": "Urinary Sediment",
  //             "examItem": "L400020003",
  //             "examName": "表皮細胞",
  //             "examEName": "Epithelial cell",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-5 (/HPF)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0-5"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "尿沉渣試驗",
  //             "groupEName": "Urinary Sediment",
  //             "examItem": "L400020007",
  //             "examName": "微生物",
  //             "examEName": "Microorganism",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "(-)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "血液系統",
  //         "deptEName": "Hematology",
  //         "examItemList": [
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000400",
  //             "examName": "白血球",
  //             "examEName": "Leukocytes",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "4-10 (x10^3/μL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "4.01"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000300",
  //             "examName": "紅血球",
  //             "examEName": "Erythrocytes",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "4.2-5.4 (x10^6/μL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "3.52"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000100",
  //             "examName": "血紅素",
  //             "examEName": "Hemoglobin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "12-16 (g/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "11.2"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000200",
  //             "examName": "血球比容",
  //             "examEName": "Hematocrit",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "37-47 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "32.7"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000600",
  //             "examName": "平均紅血球容積",
  //             "examEName": "MCV",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "81-97 (fL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "92.9"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000700",
  //             "examName": "平均紅血球血色素量",
  //             "examEName": "MCH",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "26-34 (Pg)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "31.8"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000800",
  //             "examName": "平均紅血球血色素濃度",
  //             "examEName": "MCHC",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "30-35 (g/dL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "34.3"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L500320001",
  //             "examName": "紅血球體積分佈寬度",
  //             "examEName": "RDW",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "11.5-14.5 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "12.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "周邊血液血球計數",
  //             "groupEName": "Complete Blood Count",
  //             "examItem": "L5000900",
  //             "examName": "血小板",
  //             "examEName": "Platelet",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "130-400 (x10^3/μL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "191"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "白血球分類",
  //             "groupEName": "Differential Count",
  //             "examItem": "L500050001",
  //             "examName": "嗜中性球",
  //             "examEName": "Neutrophil",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "40-75 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "51.6"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "白血球分類",
  //             "groupEName": "Differential Count",
  //             "examItem": "L500050002",
  //             "examName": "淋巴球",
  //             "examEName": "Lymphocyte",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "20-45 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "38.7"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "白血球分類",
  //             "groupEName": "Differential Count",
  //             "examItem": "L500050003",
  //             "examName": "單核球",
  //             "examEName": "Monocyte",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "2.0-10 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "6.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "白血球分類",
  //             "groupEName": "Differential Count",
  //             "examItem": "L500050004",
  //             "examName": "嗜酸性球",
  //             "examEName": "Eosinophil",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-7 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "3.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "白血球分類",
  //             "groupEName": "Differential Count",
  //             "examItem": "L500050005",
  //             "examName": "嗜鹼性球",
  //             "examEName": "Basophil",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-1.7 (%)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0.7"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "貧血相關檢查",
  //             "groupEName": "Anemia-related Examinations",
  //             "examItem": "L3004500",
  //             "examName": "鐵蛋白",
  //             "examEName": "Ferritin",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "13-150 (ng/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "191"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "腫瘤標記",
  //         "deptEName": "Tumor Biomarker",
  //         "examItemList": [
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "LI004500",
  //             "examName": "甲種胎兒蛋白",
  //             "examEName": "Alpha-fetoprotein",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-7 (ng/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "2.04"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "LI001600",
  //             "examName": "癌胚胎抗原",
  //             "examEName": "CEA",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-4.7 (ng/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "4.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "LI004100",
  //             "examName": "CA199腫瘤標記",
  //             "examEName": "CA19-9",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0-27 (U/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "256.0"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "LI003800",
  //             "examName": "CA125腫瘤標記",
  //             "examEName": "CA 125",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0-35 (U/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "18.3"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "婦科醫學",
  //         "deptEName": "Female medicine",
  //         "examItemList": [
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00030001",
  //             "examName": "生產史及婦科病史",
  //             "examEName": "Gynecological and gestational history",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "63 Y/O, MP=neurosis/ 50 y/o/; MARRIED, P2/ SEX;GYN DZ(N);OP DZ(CS x2);SYST DZ(N THYROID);CANCER DZ(N) FOR SONO/PAPA SURVEY--------"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00030002",
  //             "examName": "上次月經日期",
  //             "examEName": "LMP",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": ""
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00030003",
  //             "examName": "停經時間",
  //             "examEName": "Time to menopause",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "50y/o"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00030005",
  //             "examName": "內診判定",
  //             "examEName": "Interpretation",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "萎縮性陰道炎 (Atrophic Vaginitis)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "LO01050001",
  //             "examName": "子宮頸抹片檢查報告摘錄",
  //             "examEName": "Pap smear Findings",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀，請定期接受抹片檢查 (Within normal limit)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "T800100001",
  //             "examName": "婦科超音波報告摘錄",
  //             "examEName": "Gynecological ECHO Findings",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀( No Specific Anomaly)"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "女性乳房檢查",
  //         "deptEName": "Female Breast Examination",
  //         "examItemList": [
  //           {
  //             "groupName": "自動式全乳房立體超音波",
  //             "groupEName": "Automated Breast Volumes Scanner",
  //             "examItem": "R1130202",
  //             "examName": "自動式全乳房立體超音波",
  //             "examEName": "Automated Breast Volumes Scanner",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "Left Breast Calcification spot\r\nBI-RADS Category 2: Benign Finding"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "自動式全乳房立體超音波",
  //             "groupEName": "Automated Breast Volumes Scanner",
  //             "examItem": "R113020201",
  //             "examName": "乳房立體超音波報告摘錄",
  //             "examEName": "Automated Breast Volumes Scanner Summarized Findings",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "左側乳房鈣化點 (Left Breast Calcification spot)"
  //               },
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "總評:BI-RADS第二級: 良性發現。請每年定期追蹤檢查。 (BI-RADS Category 2: Benign Finding)"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "肌肉骨骼系統",
  //         "deptEName": "Musculoskeletal System",
  //         "examItemList": [
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R1020300",
  //             "examName": "腹部X光及腰薦椎側面X光",
  //             "examEName": "KUB & LS Spine Lateral View",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "Marginal Spur"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R102030001",
  //             "examName": "腹部X光及腰薦椎側面X光報告摘錄",
  //             "examEName": "KUB & LS Spine Lateral View",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "邊緣骨刺形成 (Marginal Spur Formation)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R1040300",
  //             "examName": "頸椎X光",
  //             "examEName": "C-spine  X-Ray",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "C4, C5 Marginal Spur"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "R104030001",
  //             "examName": "頸椎X光報告摘錄",
  //             "examEName": "C-spine  X-Ray",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "第4頸椎, 第5頸椎骨刺形成 (C4, C5 Spine Spur Formation)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "HI000014",
  //             "examName": "過往史",
  //             "examEName": "History",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "停經年齡"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "雙能量X光骨質密度",
  //             "groupEName": "Bone Mineral Density, DXA method",
  //             "examItem": "R1140400",
  //             "examName": "左髖關節骨質密度",
  //             "examEName": "Left Hip,BMD",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "骨質減少，骨折風險增加 (Osteopenia, -2.5＜T＜-1, Increased Fracture Risk of Examined Site)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "雙能量X光骨質密度",
  //             "groupEName": "Bone Mineral Density, DXA method",
  //             "examItem": "R11404002",
  //             "examName": "左髖關節T評分",
  //             "examEName": "T Score of L't Hip",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "-1.7"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "雙能量X光骨質密度",
  //             "groupEName": "Bone Mineral Density, DXA method",
  //             "examItem": "R11404003",
  //             "examName": "左髖關節骨質密度報告摘錄",
  //             "examEName": "Left Hip,BMD",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "骨質減少，骨折風險增加 (Osteopenia,  -2.5＜T＜-1, Increased Fracture Risk of Examined Site)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "雙能量X光骨質密度",
  //             "groupEName": "Bone Mineral Density, DXA method",
  //             "examItem": "R11404004",
  //             "examName": "左髖關節Z評分",
  //             "examEName": "Z Score of L't Hip",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "0.5"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "營養素與礦物質",
  //         "deptEName": "Nutrient & Mineral ",
  //         "examItemList": [
  //           {
  //             "groupName": "營養素",
  //             "groupEName": "Nutrient",
  //             "examItem": "VIT0002",
  //             "examName": "維他命 D",
  //             "examEName": "25-OH Vitamin D,(Total)",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "≧30 (ng/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "24.4"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "營養素",
  //             "groupEName": "Nutrient",
  //             "examItem": "VIT0005",
  //             "examName": "維生素 B12",
  //             "examEName": "Vitamin B12",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "197-771 (pg/mL)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "430.00"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "營養素",
  //             "groupEName": "Nutrient",
  //             "examItem": "VIT0006",
  //             "examName": "葉酸",
  //             "examEName": "Folic acid",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "4.80-37.30 (μg/L)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "15.00"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "眼科檢查",
  //         "deptEName": "Eye Examination",
  //         "examItemList": [
  //           {
  //             "groupName": "視力",
  //             "groupEName": "Visual Acuity",
  //             "examItem": "PE00040001",
  //             "examName": "右眼視力",
  //             "examEName": "Right Eye",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0.7 - 2.0",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.5"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "視力",
  //             "groupEName": "Visual Acuity",
  //             "examItem": "PE00040002",
  //             "examName": "左眼視力",
  //             "examEName": "Left Eye",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0.7 - 2.0",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "1.5"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "視力",
  //             "groupEName": "Visual Acuity",
  //             "examItem": "PE000400031",
  //             "examName": "檢查方法",
  //             "examEName": "Media of Examination",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "裸視 (With Naked Eyes)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "視力",
  //             "groupEName": "Visual Acuity",
  //             "examItem": "PE00040003",
  //             "examName": "視力判定",
  //             "examEName": "Interpretation of Visual Acuity",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "雙眼無明顯異常 (OU, Negative)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "氣壓式眼壓測定",
  //             "groupEName": "Ocular Pressure By Pneumotonometer",
  //             "examItem": "PE00040004",
  //             "examName": "右眼眼壓",
  //             "examEName": "Right Eye",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "9 - 20 (mmHg)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "12"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "氣壓式眼壓測定",
  //             "groupEName": "Ocular Pressure By Pneumotonometer",
  //             "examItem": "PE00040005",
  //             "examName": "左眼眼壓",
  //             "examEName": "Left Eye",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "9 - 20 (mmHg)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "11"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "氣壓式眼壓測定",
  //             "groupEName": "Ocular Pressure By Pneumotonometer",
  //             "examItem": "PE00040006",
  //             "examName": "眼壓判定",
  //             "examEName": "Interpretation of Ocular Acuity",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "無異狀 (Negative)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00040014",
  //             "examName": "石原色覺檢查表",
  //             "examEName": "Ishihara Test for Color vision",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "正常 (Normal)"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "",
  //             "groupEName": "",
  //             "examItem": "PE00000101",
  //             "examName": "眼底斷層掃描檢查報告摘錄",
  //             "examEName": "Optical Coherence Tomography",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "",
  //                 "isChart": false,
  //                 "isNum": false,
  //                 "rValue": "雙眼無異狀(OU Negative)"
  //               }
  //             ]
  //           }
  //         ]
  //       },
  //       {
  //         "deptName": "耳鼻喉科檢查",
  //         "deptEName": "ENT Examination",
  //         "examItemList": [
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110051",
  //             "examName": "500  赫茲",
  //             "examEName": "500 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "10"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110052",
  //             "examName": "1000 赫茲",
  //             "examEName": "1000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "15"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110053",
  //             "examName": "2000 赫茲",
  //             "examEName": "2000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "25"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110054",
  //             "examName": "3000 赫茲",
  //             "examEName": "3000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "25"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110055",
  //             "examName": "4000 赫茲",
  //             "examEName": "4000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "30"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110056",
  //             "examName": "6000  赫茲",
  //             "examEName": "6000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "35"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "右耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Right Ear",
  //             "examItem": "T700110057",
  //             "examName": "8000 赫茲",
  //             "examEName": "8000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "0",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "20"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110061",
  //             "examName": "500  赫茲",
  //             "examEName": "500 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "55"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110062",
  //             "examName": "1000  赫茲",
  //             "examEName": "1000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "65"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110063",
  //             "examName": "2000  赫茲",
  //             "examEName": "2000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "55"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110064",
  //             "examName": "3000 赫茲",
  //             "examEName": "3000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "55"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110065",
  //             "examName": "4000 赫茲",
  //             "examEName": "4000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "55"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110067",
  //             "examName": "6000 赫茲",
  //             "examEName": "6000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "65"
  //               }
  //             ]
  //           },
  //           {
  //             "groupName": "左耳聽力閥值",
  //             "groupEName": "Hearing Threshold, Left Ear",
  //             "examItem": "T700110068",
  //             "examName": "8000 赫茲",
  //             "examEName": "8000 Hz",
  //             "resultList": [
  //               {
  //                 "warnFlag": "1",
  //                 "refData": "0 - 25 (dB)",
  //                 "isChart": false,
  //                 "isNum": true,
  //                 "rValue": "60"
  //               }
  //             ]
  //           }
  //         ]
  //       }
  //     ]
  //   },
  //   "timestamp": "2026-07-22T09:44:25Z"
  // }


  ngOnInit() {
    this.isLoading = true;

    this.createMemberRequest = this.sharedStorageService.get('createMemberRequest') || null;

    // 待後端開發完開啟
    this.getLatestReport();

    // 取的近五年健檢報告
    this.getAllReports();

    // 使用 mockData 建立檢項分類
    // if (this.mockData.data) {
    //   this.examCategories = this.buildCategoriesFromMockData(this.mockData.data);

    //   if (window.innerWidth <= 768 && this.examCategories.length > 0) {
    //     this.selectedCategory = this.examCategories[0].examItem;
    //   } else {
    //     // 預設不選擇任何分類,顯示所有分類
    //     this.selectedCategory = '';
    //   }
    // }
  }

  get totalPages(): number {
    return Math.ceil(this.allReports.length / this.pageSize);
  }

  get paginatedReports(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.allReports.slice(start, start + this.pageSize);
  }

  get displayPages(): (number | string)[] {
    const pages: (number | string)[] = [];
    const total = this.totalPages;

    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    pages.push(1);

    if (this.currentPage > 3) {
      pages.push('...');
    }

    for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(total - 1, this.currentPage + 1); i++) {
      pages.push(i);
    }

    if (this.currentPage < total - 2) {
      pages.push('...');
    }

    pages.push(total);

    return pages;
  }

  // 前往欲前往的頁數
  goToPage(page: number | string): void {
    if (typeof page === 'number') {
      this.currentPage = page;
    }
  }

  // 返回上一頁
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  // 前往下一頁
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  // CB-024 下載報告
  downloadReport(caseNo: string): void {
    // 下載報告邏輯
    this.reportQueryService.downloadReport(caseNo).then(() => {
      console.log('報告下載成功');
    }).catch((error) => {
      console.error('報告下載失敗', error);
    });
  }

  // 取得檢項分類
  selectCategory(examItem: string): void {
    this.selectedCategory = examItem;
  }

  // 取得分類名稱
  get selectedCategoryName(): string {
    if (this.selectedCategory === 'all') {
      return '全部檢查項目';
    }
    const category = this.examCategories.find(cat => cat.examItem === this.selectedCategory);
    return category?.name ?? '';
  }

  // 開啟歷年紀錄側邊欄
  openReportCart(exam?: any): void {
    console.log('openReportCart 被呼叫', exam);

    if (exam) {
      // API 好了之後改用這個:
      this.getReportHistory(exam.examItem);

      // 取得歷年該檢項數值資料
      this.loadHistoricalData(exam.examItem);
    }
  }

  // 切換側邊欄
  toggleReportCart(): void {
    console.log('toggleReportCart 被呼叫');
    this.isReportCartOpen = !this.isReportCartOpen;

    const cartEl = this.reportLeftCart?.nativeElement;

    if (cartEl) {
      cartEl.classList.toggle('active');
      // 移除 body overflow 的設定,允許背景滾動
    }
  }

  // 載入歷年數據 - 假資料,實際應從後端取得 CB-055 的回應資料
  private loadHistoricalData(examItem: string): void {
    let examInfo: any = null;

    if (this.latestReportResponse) {
      for (const dept of this.latestReportResponse.deptList || []) {
        const found = dept.examItemList?.find(item => item.examItem === examItem);
        if (found && found.resultList && found.resultList.length > 0) {
          // 取第一筆 resultList 作為顯示資料
          const firstResult = found.resultList[0];
          examInfo = {
            examItem: found.examItem,
            name: found.examName,
            nameEn: found.examEName || '',
            refData: firstResult.refData || '',
            rValue: firstResult.rValue || '',
            isAbnormal: firstResult.warnFlag === '1',
            isNum: firstResult.isNum || false,
            isChart: firstResult.isChart || false
          };
          break;
        }
      }
    }

    // 儲存選中的檢項資訊
    this.selectedExamForHistory = examInfo;

    console.log('選中的檢項資訊:', this.selectedExamForHistory);

    // 直接賦值 recordList 陣列
    // this.historicalExamRecords = [
    //   {
    //     "bookDate": "20250807",
    //     "rValue": "",
    //     "warnFlag": "0"
    //   },
    //   {
    //     "bookDate": "20240805",
    //     "rValue": "",
    //     "warnFlag": "0"
    //   },
    //   {
    //     "bookDate": "20130903",
    //     "rValue": "正常 (Normal)",
    //     "warnFlag": "0"
    //   },
    //   {
    //     "bookDate": "20120927",
    //     "rValue": "正常 (Normal)",
    //     "warnFlag": "0"
    //   }
    // ];

    // 開啟側邊欄
    this.isReportCartOpen = true;
    const cartEl = this.reportLeftCart?.nativeElement;
    if (cartEl) {
      cartEl.classList.add('active');
    }
  }

  // call CB-054 查詢客戶最新報告資料
  getLatestReport() {
    const request: LatestReportRequest = {
      idNo: this.createMemberRequest?.idNo || '',
    };
    this.reportQueryService.getLatestReport(request).subscribe({
      next: (response) => {
        // 處理回應
        if (response.statusCode === 'S0000' && response.data) {
          // 取得報告 status
          this.status = response.data.bookStatus;
          if (response.data.deptList.length > 0) {

            this.latestReportResponse = response.data;
            // 建立檢項分類 - 需要將回傳值賦值給 examCategories
            this.examCategories = this.buildCategoriesData(this.latestReportResponse);
            if (window.innerWidth <= 768 && this.examCategories.length > 0) {
              this.selectedCategory = this.examCategories[0].examItem;
            } else {
              // 預設不選擇任何分類,顯示所有分類
              this.selectedCategory = '';
            }
          }
        } else if (response.statusCode === 'EL1017') {
          this.noReportData = true;
        }
        this.isLoading = false;
      },
      error: (error) => {
        // 處理錯誤
        console.error('取得最新報告失敗:', error);
        this.isLoading = false;
        this.noReportData = true;
      }
    });
  }

  //取出所有檢項目錄
  buildCategoriesData(data: LatestReportResponse): Array<{ examItem: string; name: string; hasAlert: boolean }> {
    const categories: Array<{ examItem: string; name: string; hasAlert: boolean }> = [];

    // 從 deptList 取得分類
    data.deptList?.forEach((dept) => {
      // 檢查該分類下是否有任何檢項的任何結果為異常
      const hasAlert = dept.examItemList?.some(item =>
        item.resultList?.some(result => result.warnFlag === '1')
      ) || false;

      categories.push({
        examItem: dept.deptName,
        name: dept.deptName,
        hasAlert: hasAlert
      });
    });

    return categories;
  }


  getExamsByCategory(examItem: string): any[] {
    if (!this.latestReportResponse) return [];

    // 如果是 'all',返回空陣列(因為模板會自己遍歷所有分類)
    if (examItem === 'all') return [];

    // 從 deptList 找到對應的分類
    const dept = this.latestReportResponse.deptList?.find(d => d.deptName === examItem);

    if (!dept) return [];

    // 將 examItemList 展開,每個 resultList 項目都轉換成獨立的檢項
    const exams: any[] = [];

    dept.examItemList?.forEach(item => {
      // 遍歷該檢項的所有 resultList
      item.resultList?.forEach(result => {
        exams.push({
          examItem: item.examItem,
          name: item.examName,
          nameEn: item.examEName || '',
          value: result.rValue || '',
          refData: result.refData || '',
          isAbnormal: result.warnFlag === '1',
          isChart: result.isChart || false,
          isNum: result.isNum || false
        });
      });
    });

    return exams;
  }

  // 判斷是否顯示所有分類
  get isShowAllCategories(): boolean {
    return !this.selectedCategory;
  }

  // 取得單一分類的檢項
  getCategoryExams(deptName: string): { exams: any[], groupList: { groupName: string, groupEName: string, items: any[] }[] } {
    if (!this.latestReportResponse) return { exams: [], groupList: [] };

    const dept = this.latestReportResponse.deptList?.find(d => d.deptName === deptName);
    if (!dept) return { exams: [], groupList: [] };

    const allExams = dept.examItemList?.map(item => {
      const firstResult = item.resultList?.[0];
      return {
        examItem: item.examItem,
        name: item.examName,
        nameEn: item.examEName || '',
        value: firstResult?.rValue || '',
        refData: firstResult?.refData || '',
        isAbnormal: firstResult?.warnFlag === '1',
        isChart: firstResult?.isChart || false,
        isNum: firstResult?.isNum || false,
        groupName: item.groupName || '',
        groupEName: item.groupEName || '',
      };
    }) || [];

    // 按 groupName 分組
    const groupMap = new Map<string, { groupName: string, groupEName: string, items: any[] }>();
    allExams.forEach(exam => {
      const key = exam.groupName || '';
      if (key) {
        if (!groupMap.has(key)) {
          groupMap.set(key, { groupName: exam.groupName, groupEName: exam.groupEName, items: [] });
        }
        groupMap.get(key)!.items.push(exam);
      }
    });
    return {
      exams: allExams,
      groupList: Array.from(groupMap.values()),
    };
  }


  // CB-055 查詢客戶檢項歷年紀錄
  getReportHistory(examItem: string,) {
    const request = {
      idNo: this.createMemberRequest?.idNo ?? '',
      gender: this.createMemberRequest?.gender ?? '',
      orgNo: this.latestReportResponse?.orgNo ?? this.sharedStorageService.get('userPlanRequest')?.orgNo ?? '',
      examItem: examItem,
    }

    this.reportQueryService.getReportHistory(request).subscribe({
      next: (response) => {
        if (response.statusCode === 'S0000' && response.data) {
          // 將 recordList 展開,處理每筆記錄的 resultList
          this.historicalExamRecords = response.data?.recordList?.map((record: any) => ({
            bookDate: record.bookDate,
            resultList: record.resultList || []
          })) || [];

          this.isReportCartOpen = true;
          console.log('轉換後的歷年紀錄:', this.historicalExamRecords);
          const cartEl = this.reportLeftCart?.nativeElement;
          if (cartEl) {
            cartEl.classList.add('active');
          }
        }
      },
      error: (error) => {
        console.error('查詢歷年紀錄失敗', error);
      }
    });
  }

  // CB - 023 查詢所有健檢報告
  getAllReports() {
    const request = {
      idNo: this.createMemberRequest?.idNo || '',
      range: '5' // 固定帶 5,代表查詢近五年的報告
    }
    this.reportQueryService.getAllReports(request).then(
      (res) => {
        if (res.statusCode === 'S0000' && res.data) {
          // 處理報告列表
          if (res.data.hcreportList.length === 0) {
            // 處理無報告的狀況
            this.noData = true;
          } else {
            // 待後端開發完成
            this.allReports = res.data.hcreportList.sort((a, b) => {
              return b.bookDate.localeCompare(a.bookDate);
            });
            this.noData = false;
          }
        }
      },
      (error) => {
        console.error('查詢所有報告失敗', error);
      }
    );
  }

  // 取得當前選中分類是否有異常
  get selectedCategoryHasAlert(): boolean {
    const category = this.examCategories.find(c => c.examItem === this.selectedCategory);
    return category?.hasAlert ?? false;
  }

  // 導轉回首頁
  navigateHome() {
    this.sharedStorageService.clear(); // 清除暫存資料
    this.router.navigate(['/healthcheck']).then();
  }
}
